<template>
  <div class="flex flex-col gap-4 py-4">
    <OrganizationTeamDetail :key="teamId" :team-id="teamId" @back="goToTeams" />
  </div>
</template>
<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { useApplicationModule } from '@/core/composables/use-application-module'
  import { ApplicationModule } from '@/core/models/organization'
  import OrganizationTeamDetail from '../components/OrganizationTeamDetail.vue'

  const { teamId } = defineProps<{
    teamId: string
  }>()

  const router = useRouter()
  const { hasModule } = useApplicationModule()

  const goToTeams = () => {
    router.push({ name: 'settings-organization-teams' })
  }

  onMounted(() => {
    if (!hasModule(ApplicationModule.LUMIA)) {
      router.replace({ name: 'settings-organization-general' })
    }
  })
</script>
